export default {"src":"/_next/static/media/organization.43dc7096.svg","height":24,"width":24};